<template>
  <div class="p-md ">

    <div class="app-block p-md">

      <h3 class="heading-line title is-4 has-text-weight-light"><span
          :class="'school-title-'+schoolSlug">{{ $t('candidate.messages.title') }}</span>
      </h3>


      <article class="media" v-for="message in candidateAccount.messages">
        <figure class="media-left">
          <p class="image is-64x64" v-if="!message.user || account.id !== message.user.id">
            <img :src="'/img/logos/logo-diderot.png'">
          </p>
          <p class="image is-64x64" v-else>
            <img v-if="profile_photo" width="200" height="300"
                 :src="'/profiles/'+profile_photo">
          </p>
        </figure>
        <div class="media-content" v-if="message.user">
          <div class="content">
            <p>
              <strong v-if="account.id !== message.user.id">{{ message.user.first_name }} {{
                  message.user.last_name
                }}</strong>
              <strong v-else>{{ candidate.first_name }} {{ candidate.last_name }}</strong>
              <br>
              <span v-html="message.message"></span>
              <br>
              <small><a @click="replyForm(message.id)"
                        v-if="account.id !== message.user.id">{{ $t('labels.general.reply') }}</a>
                {{ formatDate(message.date) }}
              </small>
            </p>
          </div>

          <article class="media p-t-md" v-if="replyTo === message.id">
            <figure class="media-left">
              <p class="image is-48x48" v-if="account.id === message.user.id">
                <img v-if="profile_photo" width="200" height="300"
                     :src="'/profiles/'+profile_photo">
              </p>
              <p class="image is-48x48" v-else>
                <img :src="'/img/logos/logo-diderot.png'">
              </p>
            </figure>
            <div class="media-content">
              <div class="field">
                <p class="control">
                  <quill-editor
                      :options="editorOption"
                      placeholder="..."
                      v-model="reply.message"></quill-editor>
                </p>
              </div>
              <div class="field">
                <p class="control">
                  <button :class="'button button-valid ' + isLoadingReply" @click="replyMessage">
                    {{ $t('labels.general.send') }}
                  </button>
                </p>
              </div>
            </div>
          </article>

          <article class="media" v-for="r in message.replies">
            <figure class="media-left">
              <p class="image is-48x48" v-if="account.id !== r.user.id">
                <img :src="'/img/logos/logo-diderot.png'">
              </p>
              <p class="image is-48x48" v-else>
                <img v-if="profile_photo" width="200" height="300"
                     :src="'/profiles/'+profile_photo">
              </p>
            </figure>
            <div class="media-content">
              <div class="content">
                <p>
                  <strong v-if="account.id !== r.user.id">{{ r.user.first_name }} {{ r.user.last_name }}</strong>
                  <strong v-else>{{ candidate.first_name }} {{ candidate.last_name }}</strong>
                  <br>
                  <span v-html="r.message"></span>
                  <br>
                  <small><a @click="replyForm(r.id)"
                            v-if="(account.id !== r.user.id)">{{ $t('labels.general.reply') }}</a>
                    {{ formatDate(r.date) }}
                  </small>
                </p>
              </div>

              <article class="media" v-if="replyTo === r.id">
                <figure class="media-left">
                  <p class="image is-48x48">
                    <img v-if="profile_photo" width="200" height="300"
                         :src="'/profiles/'+profile_photo">
                  </p>
                </figure>
                <div class="media-content">
                  <div class="field">
                    <p class="control">
                      <quill-editor
                          :options="editorOption"
                          placeholder="..."
                          v-model="reply.message"></quill-editor>
                    </p>
                  </div>
                  <div class="field">
                    <p class="control">
                      <button :class="'button button-valid ' + isLoadingReply"
                              @click="replyMessage">{{ $t('labels.general.send') }}
                      </button>
                    </p>
                  </div>
                </div>
              </article>

              <article class="media" v-for="lr in r.replies">
                <figure class="media-left">
                  <p class="image is-48x48" v-if="account.id !== lr.user.id">
                    <img :src="'/img/logos/logo-diderot.png'">
                  </p>
                  <p class="image is-48x48" v-else>
                    <img v-if="profile_photo" width="200" height="300"
                         :src="'/profiles/'+profile_photo">
                  </p>
                </figure>
                <div class="media-content">
                  <div class="content">
                    <p>

                      <strong v-if="account.id !== lr.user.id">{{ lr.user.first_name }} {{ lr.user.last_name }}</strong>
                      <strong v-else>{{ candidate.first_name }} {{ candidate.last_name }}</strong>
                      <br>
                      <span v-html="lr.message"></span>
                      <br>

                      <small> {{ formatDate(lr.date) }}</small>
                    </p>
                  </div>
                  <article class="media" v-for="lrr in lr.replies">
                    <figure class="media-left">
                      <p class="image is-48x48" v-if="account.id !== lrr.user.id">
                        <img :src="'/img/logos/logo-diderot.png'">
                      </p>
                      <p class="image is-48x48" v-else>
                        <img v-if="profile_photo" width="200" height="300"
                             :src="'/profiles/'+profile_photo">
                      </p>
                    </figure>
                    <div class="media-content">
                      <div class="content">
                        <p>
                          <strong v-if="account.id !== lrr.user.id">{{ lrr.user.first_name }} {{
                              lrr.user.last_name
                            }}</strong>
                          <strong v-else>{{ candidate.first_name }} {{ candidate.last_name }}</strong>
                          <br>
                          <span v-html="lrr.message"></span>
                          <br>

                          <small> {{ formatDate(lrr.date) }}</small>
                        </p>
                      </div>
                    </div>
                  </article>

                </div>


              </article>
            </div>


          </article>
        </div>

        <div class="media-content" v-else>
          <div class="content">
            <p>
              <span v-html="message.message"></span>
              <br>
              <small>
                {{ formatDate(message.date) }}<br>
              </small>
            </p>
          </div>
        </div>

      </article>
      <article class="media">
        <figure class="media-left">
          <p class="image is-64x64">
            <img v-if="profile_photo" width="200" height="300"
                 :src="'/profiles/'+profile_photo">
          </p>
        </figure>
        <div class="media-content">

          <div class="field">
            <p class="control">
              <quill-editor
                  :options="editorOption"
                  placeholder="..."
                  v-model="userMessage.message"></quill-editor>
            </p>
          </div>
          <div class="field">
            <transition name="slide-fade">
              <div class="has-text-danger has-text-centered">{{ errorMsg }}</div>
            </transition>
            <p class="control">
              <button :class="'button button-valid ' + isLoading" @click="newMessage">{{
                  $t('labels.general.send')
                }}
              </button>
            </p>
          </div>

        </div>
      </article>
    </div>
  </div>

</template>

<script>
import {mapGetters, mapActions} from 'vuex'

export default {
  data() {
    return {
      isLoading: '',
      isLoadingReply: '',
      errorMsg: '',
      error: '',
      profile_photo: '',
      userMessage: {
        message: ''
      },
      replyTo: null,
      reply: {
        messageId: null,
        message: ''
      },
      editorOption: {
        theme: 'snow',
        placeholder: '....',
        modules: {
          clipboard: {
            allowed: {
              tags: ['a', 'b', 'strong', 'u', 's', 'i', 'p', 'br', 'ul', 'ol', 'li', 'span'],
              attributes: ['href', 'rel', 'target', 'class']
            },
            keepSelection: true,
            substituteBlockElements: true,
            magicPasteLinks: true,
            hooks: {
              uponSanitizeElement(node, data, config) {
                console.log(node);
              },
            },
          },
          toolbar: [
            ['bold', 'italic', 'underline'],
            [{'list': 'ordered'}, {'list': 'bullet'}],
            [{'header': [1, 2, 3, 4, 5, 6, false]}],
            [{'font': []}],
            [{'align': []}],
            ['link'],
            ['clean']
          ]
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      account: 'auth/getAccount',
      token: 'auth/getToken'
    }),
    application() {
      return this.candidate.applications
    },
  },
  props: {
    school: {type: Object},
    schoolSlug: {type: String},
    candidate: {type: Object},
    candidateAccount: {type: Object},
  },
  methods: {
    ...mapActions({
      sendMessage: 'candidate/sendMessage',
      sendReply: 'candidate/replyMessage',
    }),
    toggleLoading: function () {
      this.isLoading = (this.isLoading === '') ? 'is-loading' : ''
    },
    toggleLoadingReply: function () {
      this.isLoadingReply = (this.isLoadingReply === '') ? 'is-loading' : ''
    },
    formatDate(date) {
      return window.moment(date.date).format('LLL');
    },
    newMessage: function () {
      this.errorMsg = ''
      if (this.userMessage.message) {
        this.toggleLoading()
        if (this.application.id) {
          this.userMessage.application_id = this.application.id
        } else {
          this.userMessage.application_id = this.candidate.application_log[0].id
        }
        this.sendMessage(this.userMessage).then(() => {
          this.userMessage.message = ''
          this.toggleLoading()
        }).catch((err) => {
          this.toggleLoading()
          this.error = err.message
        })
      } else {
        this.errorMsg = 'Veuillez saisir un message'
      }
    },
    replyForm(id) {
      this.replyTo = id
      this.reply.application_message_id = id
    },
    replyMessage: function () {
      if (this.reply.message) {
        this.toggleLoadingReply()
        if (this.application.id) {
          this.reply.application_id = this.application.id
        } else {
          this.reply.application_id = this.candidate.application_log[0].id
        }
        this.sendReply(this.reply).then(() => {
          this.toggleLoadingReply()
          this.reply.message = ''
          this.replyTo = null
        }).catch((err) => {
          this.toggleLoadingReply()
          this.error = err.message
        })
      }
    }
  },
  mounted() {
    if (this.candidate.profile_photo && this.candidate.profile_photo.length > 0) {
      this.profile_photo = this.candidate.profile_photo
    }

  }
}
</script>

<style scoped>

</style>
